var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=20px, Fill=No, Variant=arrow-sm-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.44455 17H13.889C14.7481 17 15.4446 16.3036 15.4446 15.4444V7.98883C15.4446 7.78255 15.3626 7.58472 15.2167 7.43886L11.0057 3.22781C10.8598 3.08194 10.662 3 10.4557 3H6.11122C5.25211 3 4.55566 3.69645 4.55566 4.55556V13.1111M4.55566 17L8.35019 13.2055M8.35019 13.2055C8.77244 13.6277 9.35578 13.8889 10.0001 13.8889C11.2888 13.8889 12.3334 12.8442 12.3334 11.5556C12.3334 10.2669 11.2888 9.22222 10.0001 9.22222C8.71144 9.22222 7.66677 10.2669 7.66677 11.5556C7.66677 12.1999 7.92794 12.7832 8.35019 13.2055Z",
    stroke: "#0306BA",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.5c13a261.svg";
export { ForwardRef as ReactComponent };